// ./src/utils/api/HomeAttentionService.ts
//
// WHAT IS ABOUT TO NEED THIS HOST, ACROSS EVERY EVENT (ROADMAP A2b #50).
//
// ⚠⚠ WHY THIS IS A SERVER QUERY AND NOT NINE LIST CALLS. Not one entity in this API has a DATE-RANGE
// filter — not budget items, rentals, stays, travel, artists or inventory. So "due in the next three
// days" cannot be asked for, and narrowing a page locally fails in the worst available way: ordered
// oldest-first the page fills with last year's unpaid leftovers and tomorrow's airport run never
// appears, so the card renders EMPTY AND LOOKS EXACTLY RIGHT. A window is a predicate, not an
// ordering, and no page size fixes that.
import { gql } from "@apollo/client";
import { OpResult } from "@sdflc/api-helpers";

import { ApiService } from "./ApiService";
import { WeatherForecast } from "./WeatherService";

const MY_HOME_ATTENTION_QUERY = gql`
  query myHomeAttention {
    myHomeAttention {
      code
      errors {
        name
        errors
      }
      data {
        items {
          kind
          severity
          count
          eventId
          eventTitle
          at
          who
          amount
          currencyCode
          capacity
          threshold
          coverage
          reasons
        }
        moreCount
        failedKinds
        weather {
          eventId
          eventTitle
          timezone
          locationLabel
          startsAt
          forecast {
            timezone
            hours {
              time
              isDaytime
              tempC
              feelsLikeC
              conditionCode
              description
              precipProbabilityPct
              precipMm
              windSpeedKmh
              humidityPct
              uvIndex
            }
            days {
              date
              tempMinC
              tempMaxC
              conditionCode
              description
              precipProbabilityPct
              precipMm
              sunriseTime
              sunsetTime
            }
          }
        }
      }
    }
  }
`;

/** One row on the card. Mirrors `EmAttentionItem`. */
export interface HomeAttentionItem {
  kind?: string | null;
  severity?: string | null;
  count?: number | null;
  eventId?: string | null;
  eventTitle?: string | null;
  at?: string | null;
  /** Only ever set when exactly ONE person is responsible across the grouped rows. */
  who?: string | null;
  amount?: string | null;
  currencyCode?: string | null;
  capacity?: number | null;
  /** The threshold this row was judged by (a share) — so the copy can name the host's own number. */
  threshold?: number | null;
  /** For an underfunded event: the share of projected cost that projected revenue covers. */
  coverage?: number | null;
  /** Why a forecast was judged risky: rain | wind | heat | cold. */
  reasons?: string[] | null;
}

/**
 * The forecast for the next event's venue.
 *
 * ⚠ RETURNED WHETHER OR NOT IT IS A WARNING. Seeing the weather and being warned about it are
 * different questions — an indoor event still has guests travelling to it — so the panel is
 * unconditional while the warning stays gated on exposure. One provider call serves both, and it is
 * cached server-side either way.
 */
export interface HomeWeather {
  eventId?: string | null;
  eventTitle?: string | null;
  timezone?: string | null;
  locationLabel?: string | null;
  startsAt?: string | null;
  forecast?: WeatherForecast | null;
}

export interface HomeAttentionPayload {
  items?: HomeAttentionItem[] | null;
  weather?: HomeWeather | null;
  moreCount?: number | null;
  /**
   * ⚠⚠ THE FIELD THAT DECIDES WHETHER THE PAGE MAY SAY "ALL CAUGHT UP". A source that failed returns
   * no items, which is pixel-identical to a source with nothing to report. This is the server naming
   * the ones that went quiet, and an empty list here is the client's permission to claim the
   * all-clear.
   */
  failedKinds?: string[] | null;
}

export class HomeAttentionService {
  static async mine(): Promise<OpResult> {
    return ApiService.executeQuery(MY_HOME_ATTENTION_QUERY, {});
  }
}
